import isServer from '../helpers/isServer';

const isDebugMode = () => {
  if (isServer()) return false;
  if (window.location.host.includes('experian.co.uk')) return false;
  return true;
};

export default isDebugMode;
